import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url(/images/hero-background.jpeg)' }}
      ></div>
      
      {/* Overlay for text readability */}
      <div className="absolute inset-0 bg-stone-900/40"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center">
        <div className="space-y-8 animate-fade-in">
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-light tracking-tight text-white leading-tight drop-shadow-lg">
            Bring Art To
            <br />
            <span className="italic font-serif">Your Ceiling</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-white max-w-3xl mx-auto font-light tracking-wide leading-relaxed drop-shadow-md">
            Luxury Fans Where Timeless Design Meets{' '}
            <br className="hidden md:block" />
            Whisper-Quiet Performance
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 pt-8">
            <Button
              onClick={() => scrollToSection('collections')}
              className="bg-white hover:bg-stone-100 text-stone-900 px-10 py-6 text-base tracking-widest transition-all duration-300 group shadow-lg"
              size="lg"
            >
              EXPLORE THE COLLECTION
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-200" size={20} />
            </Button>
            <Button
              onClick={() => scrollToSection('story')}
              className="bg-white hover:bg-stone-100 text-stone-900 px-10 py-6 text-base tracking-widest transition-all duration-300 group shadow-lg"
              size="lg"
            >
              OUR STORY
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-200" size={20} />
            </Button>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-px h-16 bg-white/50"></div>
      </div>
    </section>
  );
};